import React, { useCallback } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import Tile from "./components/Tile";
import { PrimaryLogoIcon } from "../../components/Icon";
import { AUTH, ROUTE } from "../../constants";
import "./styles.scss";

const Platforms = ({
  history
}) => {
  const onLaunchClick = useCallback(dpdLocalDomain => () => {
    const targetDomain = dpdLocalDomain ? AUTH.DPD_LOCAL_DOMAIN : AUTH.DPD_DOMAIN;
    const originDomain = window.location.hostname.includes(AUTH.DPD_LOCAL_DOMAIN) ? AUTH.DPD_LOCAL_DOMAIN : AUTH.DPD_DOMAIN;

    if (targetDomain === originDomain) {
      history.push({
        pathname: "/",
        search: history.location.search
      });
    } else {
      window.location.href = window.location.href.replace(originDomain, targetDomain).replace(ROUTE.PLATFORMS, "");
    }
  }, [history]);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames("mydpd-platform")
  }, /*#__PURE__*/React.createElement(PrimaryLogoIcon, null), /*#__PURE__*/React.createElement("p", {
    className: classNames("title")
  }, "Please select your shipping platform"), /*#__PURE__*/React.createElement("div", {
    className: classNames("tiles")
  }, /*#__PURE__*/React.createElement(Tile, {
    text: "MyDPD",
    onLaunch: onLaunchClick()
  }), /*#__PURE__*/React.createElement(Tile, {
    dpdLocal: true,
    text: "MyDPDLocal",
    onLaunch: onLaunchClick(true)
  })));
};

Platforms.propTypes = {
  history: PropTypes.object
};
export default Platforms;